/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbSecteurHomogeneGridDto } from './FcbSecteurHomogeneGridDto';
import {
    FcbSecteurHomogeneGridDtoFromJSON,
    FcbSecteurHomogeneGridDtoFromJSONTyped,
    FcbSecteurHomogeneGridDtoToJSON,
} from './FcbSecteurHomogeneGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbSecteurHomogeneGridDtoPaginatedResults
 */
export interface FcbSecteurHomogeneGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbSecteurHomogeneGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbSecteurHomogeneGridDto>}
     * @memberof FcbSecteurHomogeneGridDtoPaginatedResults
     */
    results?: Array<FcbSecteurHomogeneGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbSecteurHomogeneGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbSecteurHomogeneGridDtoPaginatedResults interface.
 */
export function instanceOfFcbSecteurHomogeneGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbSecteurHomogeneGridDtoPaginatedResultsFromJSON(json: any): FcbSecteurHomogeneGridDtoPaginatedResults {
    return FcbSecteurHomogeneGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbSecteurHomogeneGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbSecteurHomogeneGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbSecteurHomogeneGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbSecteurHomogeneGridDtoPaginatedResultsToJSON(value?: FcbSecteurHomogeneGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbSecteurHomogeneGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

